@use 'styles/functions/rem' as *;

.buttonsContainer {
    justify-content: end;
}
